export const BASE_URL = "https://codeheist-shop-app-backend.onrender.com";
